export const BrokerShipmentHistoryTitles = [
    'Date',
    'Customer Name',
    'Pick-Up',
    'Drop-Off',
    'Role',
    'Commodity',
    'Weight/Hd Ct',
    'Miles',
];

export const CustomerShipmentHistoryTitles = [
    'Date',
    'Contract/PO #',
    'Pick-Up',
    'Drop-Off',
    'Commodity',
    'Weight/Hd Ct',
    'Miles',
];

export const DriverShipmentHistoryTitles = [
    'Date',
    'Customer Name',
    'Pick-Up',
    'Drop-Off',
    'Commodity',
    'Weight/Hd Ct',
    'Miles',
];

export const AssociateRateShipmentHistoryTitles = ['Rate Type', 'Rate'];
